import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  GET_ALL_MULTI_BET_BONUSES,
  GET_ALL_MULTI_BET_BONUSES_RESPONSE_SUCCESS,
  CREATE_MULTI_BET_BONUS,
  UPDATE_MULTI_BET_BONUS,
  DELETE_MULTI_BET_BONUS,
} from "./actionTypes"
import {
  getAllMultiBetBonusesCall,
  createMultiBetBonusesCall,
  updateMultiBetBonusesCall,
  deleteMultiBetBonusesCall,
  API_URL,
} from "../../helpers/repository"
import {
  getAllMultiBetBonuses,
  getAllMultiBetBonusesResponseSuccess,
} from "./actions"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"

function* attemptGetAllMultiBetBonuses() {
  try {
    const response = yield call(getAllMultiBetBonusesCall)
    yield put(getAllMultiBetBonusesResponseSuccess(response.data.data))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateMultiBetBonus(action) {
  const { history } = action
  try {
    const response = yield call(createMultiBetBonusesCall, action.payload)
    showMessage("success", response.data.message)
    history.push("/promotions/multibet-bonus")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditMultiBetBonus(action) {
  const { history, redirectTo } = action
  try {
    const response = yield call(updateMultiBetBonusesCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllMultiBetBonuses())
    history.push(`/promotions/multibet-bonus`)
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeleteMultiBetBonus(action) {
  try {
    const response = yield call(deleteMultiBetBonusesCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllMultiBetBonuses())
  } catch (error) {
    showErrorMessages(error)
  }
}

function* MultiBetBonusesSaga() {
  yield takeEvery(GET_ALL_MULTI_BET_BONUSES, attemptGetAllMultiBetBonuses)
  yield takeEvery(CREATE_MULTI_BET_BONUS, attemptCreateMultiBetBonus)
  yield takeEvery(UPDATE_MULTI_BET_BONUS, attemptEditMultiBetBonus)
  yield takeEvery(DELETE_MULTI_BET_BONUS, attemptDeleteMultiBetBonus)
}

export default MultiBetBonusesSaga
